/**
 * CelebrationOverlay Component
 * Displays celebratory animation when viewer wins a bet
 */

import React, { useEffect, useState } from 'react';
import './CelebrationOverlay.css';

interface CelebrationOverlayProps {
  show: boolean;
  winAmount: number;
  onComplete: () => void;
}

interface Emoji {
  id: number;
  emoji: string;
  x: number;
  y: number;
  delay: number;
  duration: number;
}

export const CelebrationOverlay: React.FC<CelebrationOverlayProps> = ({
  show,
  winAmount,
  onComplete
}) => {
  const [emojis, setEmojis] = useState<Emoji[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  // Generate random emojis for animation
  useEffect(() => {
    if (show) {
      setIsVisible(true);
      
      // Generate 20 random emojis
      const emojiList = ['🎉', '💰', '⭐', '🎊'];
      const newEmojis: Emoji[] = [];
      
      for (let i = 0; i < 20; i++) {
        newEmojis.push({
          id: i,
          emoji: emojiList[Math.floor(Math.random() * emojiList.length)],
          x: Math.random() * 100, // Random horizontal position (0-100%)
          y: Math.random() * 100, // Random vertical position (0-100%)
          delay: Math.random() * 0.5, // Random delay (0-0.5s)
          duration: 2 + Math.random() * 2 // Random duration (2-4s)
        });
      }
      
      setEmojis(newEmojis);

      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
        
        // Call onComplete after fade-out animation completes
        setTimeout(() => {
          onComplete();
        }, 300); // Match fade-out duration
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!show) {
    return null;
  }

  return (
    <div className={`celebration-overlay ${isVisible ? 'visible' : ''}`}>
      {/* Celebration Emojis */}
      <div className="celebration-emojis">
        {emojis.map((emoji) => (
          <div
            key={emoji.id}
            className="celebration-emoji"
            style={{
              left: `${emoji.x}%`,
              top: `${emoji.y}%`,
              animationDelay: `${emoji.delay}s`,
              animationDuration: `${emoji.duration}s`
            }}
          >
            {emoji.emoji}
          </div>
        ))}
      </div>

      {/* Win Message */}
      <div className="celebration-content">
        <div className="celebration-title">YOU WIN!</div>
        <div className="celebration-amount">
          <i className="bi bi-coin"></i>
          +{winAmount.toLocaleString()} Credits
        </div>
      </div>
    </div>
  );
};

export default CelebrationOverlay;
